module.exports = __webpack_public_path__ + "static/media/Icon-open-envelope.5236487b.svg";